/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';

interface IArgs {
  currency: string;
}

interface IconsCurrencySignature {
  Element: null;

  Args: IArgs;

  Blocks: {
    default: [];
  };
}

const UiIconsCurrencyComponent = templateOnly<IconsCurrencySignature>();

export default UiIconsCurrencyComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Icons::Currency': typeof UiIconsCurrencyComponent;
  }
}
